import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { Toast } from "../../../../config/Toast";
import InputForm from "../../../../components/InputForm";
import SalaryService from "../../../../services/SalaryCalculation";
import "react-toastify/dist/ReactToastify.css";

const AddModal = (props) => {
  const data = props.dataModal;

  const workers = props.workers;
  const skills = props.skills;
  const [workerSelected, setWorkerSelected] = useState(null);
  const [skillSelected, setSkillSelected] = useState(null);

  const [orderSukses, setOrderSukses] = useState(data.orderSukses);
  const [sesiWorker, setSesiWorker] = useState(data.sesi);
  const [dailySalary, setDailySalary] = useState(data.upahHarian);
  const [insentifSalary, setInsentifSalary] = useState(data.upahInsentif);
  const [transportSalary, setTransportSalary] = useState(data.upahTransport);
  const [keramikSalary, setKeramikSalary] = useState(data.upahKeramik);
  const [lasSalary, setLasSalary] = useState(data.upahLas);
  const [buildingSalary, setBuildingSalary] = useState(data.feeBuilding);
  const [total, setTotal] = useState(data.totalUpah);
  const [note, setNote] = useState(data.notes);

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  useEffect(() => {
    const newTotal =
      +dailySalary + +insentifSalary + +transportSalary + +keramikSalary + +lasSalary + +buildingSalary;

    setTotal(newTotal);
  }, [dailySalary, insentifSalary, transportSalary, keramikSalary, lasSalary, buildingSalary]);

  const workerSelectHandler = (options) => setWorkerSelected(options);
  const skillSelectHandler = (options) => setSkillSelected(options);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!workerSelected || !skillSelected) {
      notifyFailed("Nama dan Skill Tukang Wajib Diisi");
      return;
    }

    const workerId = workerSelected.value;
    const workerName = workerSelected.label;
    const skillId = skillSelected.value;
    const skillName = skillSelected.label;

    const payload = {
      order_sukses: orderSukses ?? 0,
      project_id: data?.projectId ?? null,
      start_date: data?.attendanceDate ?? null,
      skill_id: skillId ?? null,
      sesi: sesiWorker ?? 0,
      skill_name: skillName ?? "-",
      user_id: workerId ?? null,
      worker_name: workerName ?? "-",
      upah_harian: dailySalary ?? 0,
      upah_insentif: insentifSalary ?? 0,
      upah_transport: transportSalary ?? 0,
      upah_keramik: keramikSalary ?? 0,
      upah_las: lasSalary ?? 0,
      upah_fee_building: buildingSalary ?? 0,
      keterangan: note ?? "",
    };

    SalaryService.addWorker(payload)
      .then(() => {
        notifySuccess(`Tukang berhasil ditambahkan`);
        props.setUpdate(true);
        props.closeModal();
      })
      .catch((err) => {
        console.log(err);
        notifyFailed(err.response?.data?.message || "Terjadi kesalahan");
      });
  };

  const formatToIDR = (value) => {
    if (value == null || value === "") return "";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const parseIDR = (formattedValue) => {
    if (!formattedValue) return 0;
    return Number(formattedValue.replace(/[^0-9]/g, ""));
  };

  const forms = [
    {
      margin: "mb-2",
      label: "Order Sukses",
      type: "text",
      id: "orderSukses",
      value: formatToIDR(orderSukses),
      changeHandler: (val) => setOrderSukses(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Sesi",
      type: "number",
      id: "sesiWorker",
      value: sesiWorker,
      changeHandler: (val) => setSesiWorker(Number(val)),
    },
    {
      margin: "mb-2",
      label: "Upah Harian",
      type: "text",
      id: "dailySalary",
      value: formatToIDR(dailySalary),
      changeHandler: (val) => setDailySalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Insentif",
      type: "text",
      id: "insentifSalary",
      value: formatToIDR(insentifSalary),
      changeHandler: (val) => setInsentifSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Transport",
      type: "text",
      id: "transportSalary",
      value: formatToIDR(transportSalary),
      changeHandler: (val) => setTransportSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Keramik",
      type: "text",
      id: "keramikSalary",
      value: formatToIDR(keramikSalary),
      changeHandler: (val) => setKeramikSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Las",
      type: "text",
      id: "lasSalary",
      value: formatToIDR(lasSalary),
      changeHandler: (val) => setLasSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Bangunan",
      type: "text",
      id: "buildingSalary",
      value: formatToIDR(buildingSalary),
      changeHandler: (val) => setBuildingSalary(parseIDR(val)),
    },
    {
      margin: "mb-2",
      label: "Total",
      type: "text",
      id: "total",
      value: formatToIDR(total),
      changeHandler: (e) => setTotal(parseIDR(e.target.value)),
      disabled: true,
    },
    {
      margin: "mb-2",
      label: "Keterangan",
      type: "text",
      id: "note",
      value: note,
      changeHandler: setNote,
    },
  ];

  return (
    <div className={`modal fade ${activeModal}`} id="modalAddGeneral" style={activeStyle} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered text-center" role="document">
        <div className="modal-content modal-content-demo">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">ID Project: #{data.projectId}</h5>
            <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" onClick={props.closeModal}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table text-nowrap text-md-nowrap text-center table-bordered">
                <thead className="table-info">
                  <tr>
                    <th>Tanggal</th>
                    <th>Client Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data.attendanceDate}</td>
                    <td>{data.clientName}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <form className="form-horizontal" onSubmit={submitHandler}>
              <div className="modal-body">
                <div className="row mb-2">
                  <label htmlFor="worker" className="col-md-3 form-label">
                    Nama Tukang
                  </label>
                  <div className="col-md-9">
                    <Select options={workers} value={workerSelected} onChange={workerSelectHandler} />
                  </div>
                </div>
                <div className="row mb-2">
                  <label htmlFor="skill" className="col-md-3 form-label">
                    Skill Tukang
                  </label>
                  <div className="col-md-9">
                    <Select options={skills} value={skillSelected} onChange={skillSelectHandler} />
                  </div>
                </div>

                {forms.map((form) => (
                  <InputForm key={form.id} {...form} />
                ))}
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary">Add</button>
                <button className="btn btn-light" data-bs-dismiss="modal" onClick={props.closeModal}>
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddModal;
